import { createContext } from 'react';
import { IContent } from '../../../../api/contents/interfaces/contentInterface';

/**
 * Seleção de order bumps da compra. `uuid` é o da OFERTA (paym_order_bump) —
 * o único que o pagamento reconhece; `content` carrega título/preço para o
 * resumo. Vários bumps podem ser marcados ao mesmo tempo.
 */
export type OrderBumpSelection = {
	uuid: string;
	content: IContent;
};

interface IOrderBumpContext {
	orderBumps: OrderBumpSelection[];
	/** Liga/desliga uma oferta na compra. */
	toggleOrderBump: (selection: OrderBumpSelection, checked: boolean) => void;
}

export const OrderBumpContext = createContext<IOrderBumpContext>({
	orderBumps: [],
	toggleOrderBump: () => false
});
